/** Canonical home for classroom (student role) users — no evaluation test. */
export const STUDENT_DASHBOARD_PATH = '/student_dashboard'

/**
 * Platform (punishment) lessons still run LessonsPage / get-lesson content,
 * but under StudentProtectedRoute so students never depend on fromStudentPunish=1.
 */
export const STUDENT_PLATFORM_LESSONS_PATH = '/student/platform-lessons'

export function studentPlatformLessonUrl(lessonId: string): string {
  return `${STUDENT_PLATFORM_LESSONS_PATH}?lessonId=${encodeURIComponent(lessonId)}`
}
